// extracted by mini-css-extract-plugin
module.exports = {"item":"_1Sy5wB89aOUkIanz8eRRPc","icon":"arSjolDw86I7gKfYXbxlU","name":"_1eKR7Sl1earEOijOcx3ZUM","arrow":"B_9fCtePSNiHa8y3Ck8k"};